import { makeObservable, observable, action } from "mobx";
import PageStore from "./PageStore";
import { ZERO_VALUE, ONE_VALUE } from "@utils/constants";

const DEFAULT_LIMIT = 5;
const STORE_OFFSET = 0;
const STORE_TOTAL = 0;
const STORE_PAGE = 0;
const NO_INDEX_VALUE = -1;
const FIRST_INDEX = 0;
const SECOND_INDEX = 1;
const NEXT_PAGE_OFFSET = 1;
const FOUND_INDEX_VALUE = 1;

class ListingStore {
  limit = DEFAULT_LIMIT;
  offset = STORE_OFFSET;
  total = STORE_TOTAL;
  page = STORE_PAGE;
  data = [];
  dataBeforeFilter = []; // this will be used for FE Search
  orderByKey = "id";
  orderByDirection = "asc";
  filter = [];
  sort = [];
  loading = true;
  fromFilter = false;
  showMore = false;
  dataKey = null;
  hasLessData = false;

  constructor() {
    makeObservable(this, {
      limit: observable,
      offset: observable,
      total: observable,
      page: observable,
      data: observable,
      dataBeforeFilter: observable,
      orderByKey: observable,
      orderByDirection: observable,
      filter: observable,
      loading: observable,
      fromFilter: observable,
      showMore: observable,
      dataKey: observable,
      hasLessData: observable,
      fillData: action,
      OLDfillData: action,
      getData: action,
      deepFind: action,
      handleOrderByChange: action,
      handleOrderByData: action,
      handleChangePage: action,
      handleChangeLimit: action,
      handleFilter: action,
      getDataFromFrontendSearch: action,
      refreshData: action,
      setLoading: action,
    });
  }

  setLoading(loading) {
    this.loading = loading;
  }

  fillData(
    fromFilter = false,
    callback = null,
    overrideData = false,
    hideLoading = false
  ) {
    PageStore.disableRefreshAction = true;
    // this.loading = !hideLoading;
    this.setLoading(!hideLoading);
    this.fromFilter = fromFilter;

    this.getData().then((response) => {
      if (overrideData) {
        this.data = [];
      }

      if (
        response &&
        response.data &&
        Array.isArray(response.data) &&
        Array.isArray(this.data.slice())
      ) {
        if (response.data.length) {
          if (this.showMore) {
            this.data = this.data.concat(response.data);
          } else {
            this.data = response.data;
          }
        } else {
          this.showMore = false;
        }
      } else if (response && response.data && Array.isArray(response.data)) {
        if (response.data.length) {
          this.data = response.data;
        } else {
          this.showMore = false;
        }
      } else if (response && this.dataKey && response[this.dataKey]) {

        this.data = response[this.dataKey];

        this.showMore = false;
        // }
      } else {
        this.showMore = false;
      }

      if (response && response.total) {
        this.total = response.total;
      } else {
        this.total = 0;
      }
      if (!fromFilter) this.dataBeforeFilter = this.data;
      this.page = this.offset / this.limit;
      // this.loading = false;
      this.setLoading(false);
      PageStore.disableRefreshAction = false;
      callback && callback(response);
    });
  }

  OLDfillData(fromFilter = false, callback = null) {
    // this.loading = true;
    this.setLoading(true);
    this.fromFilter = fromFilter;

    this.getData().then((response) => {
      this.data = {};
      if (response && response.data) {
        this.data = response.data;
      }

      if (response && response.total) {
        this.total = response.total;
      } else {
        this.total = 0;
      }

      if (!fromFilter) this.dataBeforeFilter = this.data;
      this.page = this.offset / this.limit;
      // this.loading = false;
      this.setLoading(false);

      callback && callback();
    });
  }

  getData() {
    // should override this
    alert("REPLACE GET DATA FUNCTION");
    return new Promise((resolve, reject) => {
      resolve([]);
    });
  }

  deepFind(obj, path) {
    for (var i = 0, path = path.split("."), len = path.length; i < len; i++) {
      obj = obj[path[i]];
    }
    return obj;
  }

  handleOrderByChange(orderByKey, orderByDirection) {
    this.offset = 0; // to reset data
    this.orderByKey = orderByKey;
    this.orderByDirection = orderByDirection;
    this.handleOrderByData(orderByKey);
  }

  handleOrderByData(orderByKey) {
    let direction = this.orderByDirection;
    if (direction === undefined) direction = "asc";

    let sorted = this.data.sort(function (a, b) {
      var partA = "";
      var partB = "";

      if (
        a !== undefined &&
        a.hasOwnProperty(orderByKey) &&
        a[orderByKey] !== undefined &&
        a[orderByKey] !== null
      )
        partA = a[orderByKey].toLowerCase();

      if (
        b !== undefined &&
        b.hasOwnProperty(orderByKey) &&
        b[orderByKey] !== undefined &&
        b[orderByKey] !== null
      )
        partB = b[orderByKey].toLowerCase();

      if (partA < partB) {
        if (direction === "desc") return FOUND_INDEX_VALUE;
        else return NO_INDEX_VALUE;
      }
      if (partA > partB) {
        if (direction === "desc") return NO_INDEX_VALUE;
        else return FOUND_INDEX_VALUE;
      }
      return ZERO_VALUE;
    });
    this.data = sorted;
  }

  handleChangePage(page) {
    this.offset = this.limit * page;
    this.fillData();
  }

  getNextPage(callback) {
    this.offset = this.offset + NEXT_PAGE_OFFSET;
    this.fillData(false, callback, false, true);
  }

  handleChangeLimit(limit) {
    this.offset = 0;
    this.limit = limit;
    this.fillData();
  }

  setAppliedFilters(
    filters = {},
    fillData = true,
    callback = null,
    overrideData = false
  ) {
    const storeFilters = [];
    Object.keys(filters)?.map((key) => {
      const singleSelectedFilter = filters[key];

      if (Array.isArray(singleSelectedFilter.value)) {
        storeFilters.push({
          ColumnName: key,
          Value: singleSelectedFilter.value.join("|"),
          Operand: "EQ",
        });
      } else {
        const isDate = singleSelectedFilter.filterType === "date";
        const isAmount = singleSelectedFilter.filterType === "amount";
        if (isDate || isAmount) {
          const hasRange = singleSelectedFilter.value.split("|").length > ONE_VALUE;
          storeFilters.push({
            ColumnName: key,
            Value: `${
              hasRange
                ? singleSelectedFilter.value.split("|")[FIRST_INDEX]
                : singleSelectedFilter.value
            }${isDate ? "T00:00:00.000" : ""}`,
            Operand: "GTE",
          });
          storeFilters.push({
            ColumnName: key,
            Value: `${
              hasRange
                ? singleSelectedFilter.value.split("|")[SECOND_INDEX]
                : singleSelectedFilter.value
            }${isDate ? "T23:59:59.999" : ""}`,
            Operand: "LTE",
          });
        } else if (singleSelectedFilter.filterType === "checkbox") {
          const valueToSend = singleSelectedFilter.value.split(",").join("|");
          storeFilters.push({
            ColumnName: key,
            Value: valueToSend,
            Operand: singleSelectedFilter.operator,
          });
        } else if (singleSelectedFilter.filterType === "boolean") {
          const valueToSend = singleSelectedFilter.value.toString();
          storeFilters.push({
            ColumnName: key,
            Value: valueToSend,
            Operand: singleSelectedFilter.operator,
          });
        } else if (singleSelectedFilter.filterType === "integer") {
          const valueToSend = parseInt(singleSelectedFilter.value);
          storeFilters.push({
            ColumnName: key,
            Value: valueToSend,
            Operand: singleSelectedFilter.operator,
          });
        } else {
          storeFilters.push({
            ColumnName: key,
            Value: singleSelectedFilter.value,
            Operand: singleSelectedFilter.operator,
          });
        }
      }
      return singleSelectedFilter;
    });
    this.filter = storeFilters.length ? [storeFilters] : null;
    this.offset = 0;
    this.data = [];
    if (fillData) {
      this.fillData(true, callback, overrideData);
    }
  }

  setAppliedSort(sort, fillData = true) {
    const storeSort = [];
    sort.map((singleSort, index) => {
      storeSort.push({
        ColumnName: singleSort.id,
        SortingLevel: index,
        SortingOrder: singleSort.direction.toUpperCase(),
      });
    });
    this.sort = storeSort;
    this.offset = 0;
    if (fillData) {
      this.fillData(true);
    }
  }

  handleFilter(key, value, type) {
    let index = this.filter.findIndex((item) => item.key === key);

    if (index > NO_INDEX_VALUE) {
      this.filter[index] = { key, value, type };
    } else {
      this.filter.push({ key, value, type });
    }

    this.offset = 0;
    this.fillData(true);
  }

  getDataFromFrontendSearch(colors = {}) {
    let { filter } = this;
    let dataAfterFilter = this.dataBeforeFilter;

    filter.forEach((filterItem) => {
      if (filterItem.type === "color") {
        let colorsObject = {};
        let availableData = [];

        Object.keys(colors).forEach((key) => {
          if (key !== "ranks") {
            if (!colorsObject[colors[key]]) colorsObject[colors[key]] = [];
            colorsObject[colors[key]].push(key);
          }
        });

        if (typeof filterItem.value !== "string") {
          if (!filterItem.value.length) {
            Object.keys(colorsObject).forEach((key) => {
              availableData.push(colorsObject[key]);
            });
          } else {
            filterItem.value.forEach((value) => {
              availableData.push(colorsObject[value]);
            });
          }
          availableData = availableData.flat();

          dataAfterFilter = dataAfterFilter.filter((item) =>
            availableData.includes(item[filterItem.key])
          );
        }
      } else {
        dataAfterFilter = dataAfterFilter.filter((item) => {
          let value = null;
          filterItem.key.split(".").forEach((key) => {
            if (!value) {
              value = item[key];
            } else {
              value = value[key];
            }
          });

          return value.toLowerCase().includes(filterItem.value.toLowerCase());
        });
      }
    });

    return dataAfterFilter;
  }

  refreshData(
    enableShowMore = true,
    refreshDataAfterLoad = false,
    callback = null,
    overrideData = false
  ) {
    this.offset = 0;
    this.total = 0;
    this.page = 0;
    if (!refreshDataAfterLoad) {
      this.data = [];
    }
    // this.loading = true;
    this.setLoading(true);
    this.showMore = enableShowMore;
    this.fillData(false, callback, overrideData);
  }
}

export default ListingStore;
